"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSideToSideNumber = exports.convertSideNumberToSide = exports.localizeString = exports.romanNumeral = exports.getContractionStatus = void 0;
exports.getMarkupByDamageType = getMarkupByDamageType;
exports.unitMatchesDamageType = unitMatchesDamageType;
exports.separateEpigraphicUnitsByWord = separateEpigraphicUnitsByWord;
exports.getEpigraphicSeparator = getEpigraphicSeparator;
exports.epigraphicWordWithSeparators = epigraphicWordWithSeparators;
exports.undeterminedReading = undeterminedReading;
exports.regionReading = regionReading;
exports.convertMarkedUpUnitsToLineReading = convertMarkedUpUnitsToLineReading;
exports.convertMarkedUpUnitsToEpigraphicWords = convertMarkedUpUnitsToEpigraphicWords;
exports.formatLineNumber = formatLineNumber;
var superscriptChars = {
    '0': '⁰',
    '1': '¹',
    '2': '²',
    '3': '³',
    '4': '⁴',
    '5': '⁵',
    '6': '⁶',
    '7': '⁷',
    '8': '⁸',
    '9': '⁹',
    '+': '⁺',
    '-': '⁻',
    '=': '⁼',
    '(': '⁽',
    ')': '⁾',
    Á: 'ᴬ',
    É: 'ᴱ',
    Í: 'ᴵ',
    Ú: 'ᵁ',
    À: 'ᴬ',
    È: 'ᴱ',
    Ì: 'ᴵ',
    Ù: 'ᵁ',
    a: 'ᵃ',
    b: 'ᵇ',
    c: 'ᶜ',
    d: 'ᵈ',
    e: 'ᵉ',
    f: 'ᶠ',
    g: 'ᵍ',
    h: 'ʰ',
    i: 'ⁱ',
    j: 'ʲ',
    k: 'ᵏ',
    l: 'ˡ',
    m: 'ᵐ',
    n: 'ⁿ',
    o: 'ᵒ',
    p: 'ᵖ',
    r: 'ʳ',
    s: 'ˢ',
    t: 'ᵗ',
    u: 'ᵘ',
    v: 'ᵛ',
    w: 'ʷ',
    x: 'ˣ',
    y: 'ʸ',
    z: 'ᶻ',
    A: 'ᴬ',
    B: 'ᴮ',
    D: 'ᴰ',
    E: 'ᴱ',
    G: 'ᴳ',
    H: 'ᴴ',
    Ḫ: 'ᴴ',
    I: 'ᴵ',
    J: 'ᴶ',
    K: 'ᴷ',
    L: 'ᴸ',
    M: 'ᴹ',
    N: 'ᴺ',
    O: 'ᴼ',
    P: 'ᴾ',
    R: 'ᴿ',
    S: 'ˢ',
    Š: 'ˢᶻ',
    T: 'ᵀ',
    U: 'ᵁ',
    V: 'ⱽ',
    W: 'ᵂ',
    X: 'ᵡ',
};
function getMarkupByDamageType(markupUnits, damageType) {
    return markupUnits.find(function (unit) { return unit.type === damageType; });
}
function unitMatchesDamageType(neighbor, markupType) {
    if (neighbor.markups) {
        var match = neighbor.markups.some(function (markup) {
            if (markup.type === markupType) {
                return true;
            }
            return false;
        });
        return match;
    }
    return false;
}
function separateEpigraphicUnitsByWord(characters) {
    var words = [];
    var lastDiscourseUuid = '';
    var curWordIdx = -1;
    characters.forEach(function (character, idx) {
        if (lastDiscourseUuid === character.discourseUuid) {
            words[curWordIdx].push(character);
            lastDiscourseUuid = character.discourseUuid;
        }
        else if (characters
            .slice(idx + 1)
            .map(function (char) { return char.discourseUuid; })
            .includes(lastDiscourseUuid || '')) {
            words[curWordIdx].push(character);
        }
        else {
            curWordIdx += 1;
            words[curWordIdx] = [character];
            lastDiscourseUuid = character.discourseUuid;
        }
    });
    return words;
}
function getEpigraphicSeparator(sign1, sign2, isContraction) {
    if (sign2) {
        if (!sign1.markups.map(function (unit) { return unit.type; }).includes('phoneticComplement') &&
            sign2.markups.map(function (unit) { return unit.type; }).includes('phoneticComplement')) {
            return '';
        }
        if (sign1.type === 'determinative' || sign2.type === 'determinative') {
            return '';
        }
        if (sign1.type === 'phonogram' || sign2.type === 'phonogram') {
            return '-';
        }
        if (sign1.type === 'number' && sign2.type === 'number') {
            return '+';
        }
        if (sign1.type === 'logogram' || sign2.type === 'logogram') {
            return '.';
        }
    }
    else if (isContraction) {
        return '-';
    }
    return '';
}
function epigraphicWordWithSeparators(characters, isContraction) {
    var wordWithSeparators = '';
    characters.forEach(function (character, index) {
        wordWithSeparators += character.reading;
        var nextSign = index !== characters.length - 1 ? characters[index + 1] : null;
        wordWithSeparators += getEpigraphicSeparator(character, nextSign, isContraction);
    });
    return wordWithSeparators;
}
function undeterminedReading(unit) {
    if (unit.markups.length > 0) {
        var markupValue = unit.markups[0].value;
        if (markupValue === null) {
            return 'undetermined';
        }
        if (markupValue === 1) {
            return '1 broken line';
        }
        return "".concat(markupValue, " broken lines");
    }
    return '';
}
function regionReading(unit) {
    if (unit.markups.length > 0) {
        var _a = unit.markups[0], markupType = _a.type, markupValue = _a.value;
        var reading = unit.reading;
        if (markupType === 'isSealImpression') {
            if (reading === null) {
                return 'Seal Impression';
            }
            return "Seal Impression ".concat(reading);
        }
        if (markupType === 'broken') {
            return 'broken';
        }
        if (markupType === 'uninscribed') {
            if (markupValue === null) {
                return 'uninscribed';
            }
            if (markupValue === 1) {
                return '1 uninscribed line';
            }
            return "".concat(markupValue, " uninscribed lines");
        }
        if (markupType === 'ruling') {
            if (markupValue === 1) {
                return '---- Single Ruling ----';
            }
            if (markupValue === 2) {
                return '---- Double Ruling ----';
            }
            if (markupValue === 3) {
                return '---- Triple Ruling ----';
            }
            return '-'.repeat(12);
        }
        if (markupType === 'isStampSealImpression') {
            var valueReading = "(".concat(markupValue, ")");
            return "Stamp Seal Impression ".concat(reading || '', " ").concat(markupValue !== null ? valueReading : '').trim();
        }
    }
    return '';
}
function convertMarkedUpUnitsToLineReading(characters, isRegular) {
    var superscriptedCharacters = characters.map(function (character) {
        return character.type === 'determinative' && isRegular
            ? __assign(__assign({}, character), { reading: superscript(character.reading) }) : character;
    });
    var epigraphicWords = separateEpigraphicUnitsByWord(superscriptedCharacters);
    return epigraphicWords
        .map(function (word) {
        var isContraction = (0, exports.getContractionStatus)(word);
        return epigraphicWordWithSeparators(word, isContraction);
    })
        .join(' ');
}
function convertMarkedUpUnitsToEpigraphicWords(characters) {
    var epigraphicWords = separateEpigraphicUnitsByWord(characters);
    return epigraphicWords.map(function (signs) {
        var isContraction = (0, exports.getContractionStatus)(signs);
        return {
            uuids: signs.map(function (unit) { return unit.uuid; }),
            reading: epigraphicWordWithSeparators(signs, isContraction),
            discourseUuid: signs[0].discourseUuid,
            signs: signs.map(function (sign, idx) { return ({
                uuid: sign.uuid,
                epigType: sign.epigType,
                type: sign.type,
                signUuid: sign.signUuid,
                readingUuid: sign.readingUuid,
                reading: sign.reading,
                separator: getEpigraphicSeparator(sign, idx !== signs.length - 1 ? signs[idx + 1] : null, isContraction),
                markups: sign.markups,
                objOnTablet: sign.objOnTablet,
                discourseUuid: sign.discourseUuid,
            }); }),
            isContraction: isContraction,
            word: signs[0].word || null,
            form: signs[0].form || null,
            translation: signs[0].translation || null,
            parseInfo: signs[0].parseInfo || null,
            isNumber: signs[0].epigType === 'number',
            isDivider: signs.map(function (unit) { return unit.epigType; }).includes('separator'),
        };
    });
}
var getContractionStatus = function (word) {
    var spellingUuid = word.map(function (sign) { return sign.spellingUuid; })[0];
    if (spellingUuid === '548189514651019744125244140023458311' ||
        spellingUuid === '548385815967702358357593121218684988') {
        return true;
    }
    return false;
};
exports.getContractionStatus = getContractionStatus;
function formatLineNumber(lineNum, includePeriod) {
    if (includePeriod === void 0) { includePeriod = true; }
    var lineNumber = '';
    if (Number.isInteger(lineNum)) {
        lineNumber = "".concat(lineNum).concat(includePeriod ? '.' : '');
    }
    else {
        var numAsString = String(lineNum);
        lineNumber = numAsString.slice(0, numAsString.indexOf('.'));
        var decimalPlaces = numAsString.slice(numAsString.indexOf('.'), numAsString.indexOf('.') + 3);
        var numHyphens = Number(decimalPlaces) * 100;
        for (var i = 0; i < numHyphens; i += 1) {
            lineNumber += "'";
        }
    }
    return lineNumber;
}
var romanNumeral = function (colNum) {
    var numeral = '';
    switch (colNum) {
        case 1:
            numeral = 'i';
            break;
        case 2:
            numeral = 'ii';
            break;
        case 3:
            numeral = 'iii';
            break;
        case 4:
            numeral = 'iv';
            break;
        case 5:
            numeral = 'v';
            break;
        case 6:
            numeral = 'vi';
            break;
        case 7:
            numeral = 'vii';
            break;
        case 8:
            numeral = 'viii';
            break;
        case 9:
            numeral = 'ix';
            break;
        case 10:
            numeral = 'x';
            break;
        default:
            numeral = "".concat(colNum);
    }
    return numeral;
};
exports.romanNumeral = romanNumeral;
function superscript(reading) {
    var add2 = false;
    var add3 = false;
    var newReading = reading
        .split('')
        .map(function (value) {
        var newValue = value;
        if (/[ÁÉÍÚ]/g.test(newValue.toLocaleUpperCase())) {
            add2 = true;
        }
        else if (/[ÀÈÌÙ]/g.test(newValue.toLocaleUpperCase())) {
            add3 = true;
        }
        if (Object.keys(superscriptChars).includes(newValue)) {
            var idx = Object.keys(superscriptChars).indexOf(newValue);
            newValue = Object.values(superscriptChars)[idx];
        }
        return newValue;
    })
        .join('');
    if (add2) {
        newReading = "".concat(newReading, "\u00B2");
    }
    else if (add3) {
        newReading = "".concat(newReading, "\u00B3");
    }
    return newReading;
}
var localizeString = function (string, locale) {
    if (locale === 'tr') {
        return string.replace(/I/g, 'İ');
    }
    return string;
};
exports.localizeString = localizeString;
var sideNumbers = {
    1: 'obv.',
    2: 'lo.e.',
    3: 'rev.',
    4: 'u.e.',
    5: 'le.e.',
    6: 'r.e.',
    7: 'mirror text',
    8: 'legend',
    9: 'suppl. tablet',
    10: 'obv. ii',
};
var convertSideNumberToSide = function (sideNum) {
    var sideName = sideNumbers[sideNum] || null;
    return sideName;
};
exports.convertSideNumberToSide = convertSideNumberToSide;
var convertSideToSideNumber = function (side) {
    var sideNum = Object.keys(sideNumbers).find(function (key) { return sideNumbers[Number(key)] === side; });
    return Number(sideNum);
};
exports.convertSideToSideNumber = convertSideToSideNumber;
//# sourceMappingURL=index.js.map